import React, { useEffect, useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import BaseService from "../../../services/BaseService";
import { Translate } from "../../Enums/Tranlate";
import BannerService from "../../../services/BannerService";
import Loader from "../../common/Loader";
import imageIcon from "../../../images/image-icon.svg";
import upload from "../../../images/upload.svg";
import "./style.scss";

const ImageModal = ({ modal, setModal, image, title }) => {
	return (
		<Modal show={modal} onHide={setModal}>
			<a href={image} target="_blank" rel="noreferrer" className="w-100 h-100">
				<img src={image} alt={title} className="w-100 h-100" />
			</a>
		</Modal>
	);
};
const Banners = () => {
	const initial = {
		header: { src: "", loading: false, size: "1440*650" },
		projects: { src: "", loading: false, size: "1440*550" },
		media: { src: "", loading: false, size: "1440*550" },
		about: { src: "", loading: false, size: "1440*550" },
		terms: { src: "", loading: false, size: "1440*550" },
		policy: { src: "", loading: false, size: "1440*550" },
		contact: { src: "", loading: false, size: "1440*550" },
	};
	const [formData, setFormData] = useState(initial);
	const [shouldUpdate, setShouldUpdate] = useState(false);
	const [modal, setModal] = useState(false);
	const [selectedImage, setSelectedImage] = useState({});
	const lang = useSelector((state) => state.auth?.lang);
	const bannerService = new BannerService();

	useEffect(() => {
		setFormData(initial);
		bannerService.getList().then((res) => {
			if (res?.status) {
				let response = res?.data?.data?.data;
				if (!!response?.length) {
					let data = {};
					response?.map((banner) => {
						data[banner?.tag] = {
							src: banner?.banner_images[0]?.url,
							id: banner?.id,
							loading: false,
							size: formData[banner?.tag]?.size,
						};
					});
					setFormData((prev) => ({ ...prev, ...data }));
				}
			}
		});
	}, [shouldUpdate]);

	const deleteBanner = (title, value) => {
		setFormData((prev) => ({
			...prev,
			[title]: { ...value, loading: true },
		}));
		bannerService.remove(value?.id).then((response) => {
			if (response?.status) {
				toast.success(response?.data?.message);
				setFormData((prev) => ({
					...prev,
					[title]: { src: "", loading: false, size: formData[title].size },
				}));
			}
		});
	};

	const fileHandler = (e, title, value) => {
		let files = e.target.files;
		const filesData = Object.values(files);
		if (filesData?.length) {
			setFormData((prev) => ({
				...prev,
				[title]: { ...value, loading: true },
			}));
			new BaseService().postUpload(filesData[0]).then((res) => {
				if (res?.status === 200) {
					let data = {
						images: [res?.data?.url],
						tag: title,
					};
					bannerService.create(data).then((response) => {
						if (response?.status === 201) {
							toast.success(response?.data?.message);
							setShouldUpdate((prev) => !prev);
						}
					});
				} else {
					setFormData((prev) => ({
						...prev,
						[title]: { ...value, loading: false },
					}));
				}
			});
		}
	};

	return (
		<Row>
			<Col md={10}>
				<Row className="mb-3">
					{Object.entries(formData).map(([key, value]) => (
						<div className="col-12 mb-5" key={key}>
							<p className="mb-0 text-black fw-bold">{Translate[lang][key]}</p>
							<div
								style={{
									border: "1px solid rgb(205, 206, 215)",
									padding: "8px",
									borderRadius: "16px",
								}}
								className="form-group mb-0 position-relative w-100">
								<div className="banner">
									<div className="banner-img">
										{!value?.src && <img src={imageIcon} alt="imageIcon" />}
										{!!value?.src && (
											<img
												src={value?.src}
												alt={key}
												className="w-100 h-100"
												onClick={() => {
													setSelectedImage({ title: key, ...value });
													setModal(true);
												}}
											/>
										)}
									</div>
									<div>
										<span className="max">
											{Translate[lang]?.max_size} 100 {Translate[lang]?.mbs} /{" "}
											{value?.size}
										</span>
										<div
											className="d-flex mt-2"
											style={{
												gap: "24px",
												opacity: value.loading ? ".8" : "1",
											}}>
											{!value?.src && (
												<label className="custum-file-upload" htmlFor="file">
													<div className="icon">
														<img src={upload} alt="upload" />
													</div>

													<div>
														<span className="text">
															{Translate[lang].upload_image}
														</span>
													</div>
													{!value.loading && (
														<input
															type="file"
															accept="image/*"
															onChange={(e) => fileHandler(e, key, value)}
															className="upload"
															name="Upload"
														/>
													)}
												</label>
											)}

											{!!value?.src && (
												<button
													disabled={value.loading}
													className="delete-img"
													type="button"
													onClick={() => deleteBanner(key, value)}>
													<i className="la la-trash" />
													{Translate[lang].delete}
												</button>
											)}
											{value.loading && <Loader />}
										</div>
									</div>
								</div>
							</div>
						</div>
					))}
				</Row>
			</Col>
			{modal && (
				<ImageModal
					modal={modal}
					setModal={() => setModal(false)}
					title={selectedImage?.title}
					image={selectedImage?.src}
				/>
			)}
		</Row>
	);
};

export default Banners;
